import numUtils from '@/helpers/numUtils'
import dateUtils from '@/helpers/dateUtils'

function apiToTransaction(data) {
  return {
    id: data.transactionId,
    type: data.type,
    date: dateUtils.formatDate(new Date(data.date)),
    c1Amount: data.currency1Amount ? numUtils.formatStrNum(data.currency1Amount) : null,
    c1: data.currency1,
    c2Amount: data.currency2Amount ? numUtils.formatStrNum(data.currency2Amount) : null,
    c2: data.currency2,
    valueBGN: +data.bgnAmount ? numUtils.formatStrNum(data.bgnAmount) : null,
  }
}

function apiToPortfolio(data) {
  const totals = data.totals

  let portfolio = {
    id: data.id,
    assets: data.assets.filter(asset => asset.pieces > 0).map(asset => {
      asset.valueBGNstr = numUtils.roundTo(asset.valueBGN, 2)
      asset.valueBGN = numUtils.round(asset.valueBGN, 0)
      asset.priceBGNstr = numUtils.roundTo(asset.priceBGN, 2)
      asset.shareStr = numUtils.roundTo(asset.share * 100, 2)
      asset.piecesStr = numUtils.precisionRound(asset.pieces, 8).toFixed(8)
      return asset
    }),
    stats: {
      roi: {},
      totalValueBGN: numUtils.roundTo(+totals.totalValueBGN, 2),
      totalDepositsBGN: numUtils.roundTo(+totals.totalDepositsBGN, 2),
      totalWithdrawalsBGN: numUtils.roundTo(+totals.totalWithdrawalsBGN, 2),
      totalCommissionsBGN: numUtils.roundTo(+totals.totalCommissionsBGN, 2),
      netProfitBGN: numUtils.roundTo(+totals.totalValueBGN + +totals.totalWithdrawalsBGN - +totals.totalDepositsBGN, 2),
    },
    updateTime: data.updateTime ? dateUtils.formatDateTime(new Date(data.updateTime)) : null,
  }

  for (var periodKey in data.ROI) {
    var periodValues = data.ROI[periodKey]
    if (periodValues) {
      portfolio.stats.roi[periodKey] = {}
      for (var valueKey in periodValues) {
        portfolio.stats.roi[periodKey][valueKey] = numUtils.roundTo(periodValues[valueKey], 2)
      }
    }
  }

  return portfolio
}

export {
  apiToTransaction,
  apiToPortfolio,
}



// WEBPACK FOOTER //
// ./src/services/converters.js